(function ($) {
  $(document).ready(function ($) {
    const $cursor = $('#main-cursor');
    const $html = $('body')

    $html.on('mousemove', (e) => {

      if ($(e.target).is(".wp-block-gallery img")) {
        $cursor.hide()
        return
      }
      $cursor.show()

      // move cursor
      $cursor.css({"top": e.clientY, "left": e.clientX});

      // add mix blend mode for links
      if ($(e.target).is("a, a *, .description")) {
        $cursor.addClass('hover');
      } else {
        $cursor.removeClass('hover');
      }
      localStorage.setItem('cursor', JSON.stringify({clientY: e.clientY, clientX: e.clientX}));
    });

    $html.on('mouseleave', () => {
      $cursor.hide();
    });

    const position = JSON.parse(localStorage.getItem('cursor'));
    $cursor.css({"top": position.clientY, "left": position.clientX});
  })
})(jQuery)
